/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2022-02-24 14:52:38
 * @modify date 2022-02-24 14:52:38
 * @desc [基础模块 ]
 * @nexus 公共库托管 https://maven.xpaas.lenovo.com/nexus/service/rest/repository/browse/bpportal/%40mamba/libraries/
 * @update 需要自定义可拷贝 node_modules>@mamba>libraries>src 源码进行更改
 * @info 托管目的是统一所有仓库能够引用一个基础模块，有bug可以直接更新依赖解决
 */
export * from '@mamba-le/auth';
export * from '@mamba-le/libraries';
